(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        $(function () {
            $('main').on('click', '.popular-countries-menu li > span', function () {
                var departCityId = $(this).data('city');
                var alterCityId = $(this).data('alternativeCity');
                var selectors = ['.popular-countries-items', '.popular-countries-flight'];

                selectors.forEach(function (selector) {
                    var $tag = $(selector);
                    if ($tag.hasClass('active')) {
                        $tag.removeClass('active');
                    }
                });

                $('.' + departCityId).addClass('active');
                $('.' + alterCityId).addClass('active');
                $('.popular-countries-menu li').removeClass('active');
                $(this).closest('li').addClass('active');
                $('.popular-countries-menu .dropdown-toggle').text($(this).data('name'));
            });

            $('.popular-countries').find('div.destination-item').each(function (index, element) {
                $(element).replaceWith(function () {
                    return $('<a>', { html: this.innerHTML, href: this.dataset.href, class: 'destination-item' });
                });
            });

            $(document).on('widget:change-city', function (event, cityName) {
                var $li = $('.popular-countries-menu').find("span[data-name=\"" + cityName + "\"]");
                if ($li.length) {
                    $li.trigger('click');
                }
            });
        });
    }, {}] }, {}, [1]);